<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="col-12">
        <label>{{row.customerName}} - {{row.contractTemplateName}}</label>

      </div>
    </div>
  </nb-card-header>
 <nb-card-body [nbSpinner]="this.isLoading">
  <div id="droparea2">
    <div class="area">
  
      <ejs-uploader 
        #defaultupload  
        [autoUpload]="false" 
        [dropArea]="dropEle" 
        (selected)="onUploadSuccess($event)"
        (clearing)="resetDropAreaVisibility($event)"
        [asyncSettings]='path' >
      </ejs-uploader><br>
      <div  *ngIf="isDropAreaVisible">
      <h6 style=" margin: 0px 0px 10px;">OR</h6>
      <span style="font-size: 18px;">Drop files here to upload</span>
    </div>
    </div>
  </div> 

  </nb-card-body>

  

  <nb-card-footer>
    <div class="row">
      <div class="col-12" style="text-align: right">
        <button mat-stroked-button (click)="cancel()">
          <fa-icon [icon]="faClose"></fa-icon> Cancel
        </button>
        <button
          class="saveButton"
          style="margin-left: 10px"
          mat-raised-button [disabled]="isLoading"
          (click)="save()"
        >
          <fa-icon [icon]="faSave"></fa-icon> Save
        </button>
      </div>
    </div>
  </nb-card-footer>
</nb-card>

